import type { PokemonV2 } from '../types/pokemon';

const PUBLIC_URL = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const POKEMON_MASTER_LIST_URL = `${PUBLIC_URL}/data/pokemon-list.json`;

let cachedPokemonMasterList: PokemonV2[] | null = null;
// 同時アクセスを1回のfetchにまとめるための共有Promise
let loadPromise: Promise<PokemonV2[]> | null = null;
const EMPTY_POKEMON_LIST: PokemonV2[] = [];

const normalizeMasterList = (data: unknown): PokemonV2[] => {
  // 形式が想定外でも落ちないよう配列以外は空扱いにする
  if (!Array.isArray(data)) {
    return EMPTY_POKEMON_LIST;
  }
  // `([])` が付与された不正なフォーム名は、候補に出ると混乱するため除外する
  return (data as PokemonV2[]).filter((pokemon) => {
    return !(typeof pokemon?.name_ja === 'string' && pokemon.name_ja.includes('([])'));
  });
};

// ポケモンの元データ（生成物）を取得するためのアクセサ
export const getPokemonMasterList = (): PokemonV2[] =>
  cachedPokemonMasterList ?? EMPTY_POKEMON_LIST;

export const setPokemonMasterList = (list: PokemonV2[]) => {
  // テストや事前読み込みでキャッシュを差し替える用途
  // `loadPokemonMasterList` と同様の正規化を通して、`([])` 等の不正データ混入を防ぐ
  cachedPokemonMasterList = normalizeMasterList(list);
  loadPromise = Promise.resolve(cachedPokemonMasterList);
};

export const loadPokemonMasterList = async (): Promise<PokemonV2[]> => {
  if (cachedPokemonMasterList) {
    return cachedPokemonMasterList;
  }
  // 既に読み込み中なら同じPromiseを返す
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = fetch(POKEMON_MASTER_LIST_URL)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`ポケモンマスターデータの取得に失敗しました: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      cachedPokemonMasterList = normalizeMasterList(data);
      return cachedPokemonMasterList;
    })
    .catch((error) => {
      console.error('ポケモンマスターデータの取得に失敗しました:', error);
      cachedPokemonMasterList = EMPTY_POKEMON_LIST;
      return cachedPokemonMasterList;
    });
  return loadPromise;
};
